import { Link } from 'react-router-dom';
import { BoxesIcon, ReceiptIcon, SunIcon } from 'lucide-react';
import { ADMIN_BASE } from '../../utils/hosts';
import { adminSections } from '../../data/adminSections';
import { useAdmin } from '../AdminContext';
import { useAttention } from '../attention/useAttention';
import { AttentionList } from './AttentionList';
import { TodayAgenda } from './TodayAgenda';
import { HandoffNotesPanel } from './HandoffNotesPanel';
import { StaffDaySummaryPanel } from './StaffDaySummaryPanel';
import { LaunchChecklist } from './LaunchChecklist';
import { RevenueTile } from '../sales/RevenueTile';
import { OutstandingVouchersTile } from '../vouchers/OutstandingVouchersTile';
import { btnPrimary, btnSecondary } from '../ui/styles';
import { longDate } from '../../core/format/dates';
import { greeting, plural } from '../../core/format/text';
import { API_BASE } from '../../core/api/http';

/**
 * Vandaag voor Sarah. Links wat er op haar wacht (useAttention: Nu · Deze week · Winkel op orde),
 * rechts haar dag in de salon en twee cijfers. Hier alleen de twee handelingen van elke dag.
 */
export function OwnerToday() {
  const {
    user
  } = useAdmin();
  const {
    groups,
    urgent,
    total,
    loading
  } = useAttention();
  const summary = loading ? ' ' : total === 0 ? 'Er ligt niets op je te wachten.' : urgent > 0 ? `${plural(urgent, 'ding wacht', 'dingen wachten')} op je.${total > urgent ? ` De rest kan later deze week.` : ''}` : `Niets dringends. ${plural(total, 'ding', 'dingen')} voor deze week.`;
  return <div data-id="element-1588" data-mp="33hoexby24jbs">
      <header className="mb-8 flex flex-col gap-5 sm:mb-10 lg:flex-row lg:items-end lg:justify-between" data-id="element-1589" data-mp="33hg21k1xpe0l">
        <div className="min-w-0" data-id="element-1590" data-mp="38cc3fat29dqd">
          <p className="text-[14px] capitalize text-muted" data-id="element-1591" data-mp="3d9u3ebp3oim8">{longDate(new Date())}</p>
          <h1 className="mt-1 font-display text-[2rem] font-light leading-tight text-ink sm:text-[2.4rem]" data-id="element-1592" data-mp="3hb7bytjkuzwu">
            {greeting()}, <span className="italic text-clay" data-id="element-1593" data-mp="3m98wliwnj7af">{user.name}.</span>
          </h1>
          <p className="mt-2 min-h-[1.25rem] text-[14px] text-muted" aria-live="polite" data-id="element-1594" data-mp="1m7hmr2zi234o">
            {summary}
          </p>
        </div>
        <div className="flex flex-wrap gap-2" data-id="element-1595" data-mp="1i7gxenav47iu">
          <Link to={`${ADMIN_BASE}${adminSections.mijnDag.path}`} className={btnSecondary} data-id="element-1596" data-mp="1vxkgx6icxn4l">
            <SunIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-1597" data-mp="1vzeyqbyc0z4g" />
            Mijn dag
          </Link>
          <Link to="/be/kassa" className={btnPrimary} data-id="element-1598" data-mp="25vi3lpkkjbv3">
            <ReceiptIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-1599" data-mp="25tx91zy97sx8" />
            Afrekenen
          </Link>
          <Link to="/be/voorraad?tab=inkoop" className={btnSecondary} data-id="element-1600" data-mp="20z04b580c5q5">
            <BoxesIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-1601" data-mp="2evnazzpria99" />
            Inkoop boeken
          </Link>
        </div>
      </header>

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12" data-id="element-1602" data-mp="khvt6cxa4k2q">
        <div className="min-w-0 lg:col-span-7 xl:col-span-8" data-id="element-1603" data-mp="kk8jpeh3s2re">
          <AttentionList groups={groups} loading={loading} data-id="element-1604" data-mp="fkm4x0lmmegh" />
        </div>
        <aside className="min-w-0 space-y-6 lg:col-span-5 xl:col-span-4" aria-label="Je dag en cijfers" data-id="element-1605" data-mp="2r65z3yia3rvf">
          <HandoffNotesPanel data-id="element-1606" data-mp="2w60n9uao63cs" />
          <StaffDaySummaryPanel data-id="element-1607" data-mp="2w58z34jej7wj" />
          <TodayAgenda data-id="element-1608" data-mp="2ieccpvg2jmxx" />
          <RevenueTile data-id="element-1609" data-mp="2ievrx4ec3x89" />
          <OutstandingVouchersTile data-id="element-1610" data-mp="2idksfgrx9bmy" />
        </aside>
      </div>

      <div className="mt-10" data-id="element-1611" data-mp="2mffr0digxax1">
        <LaunchChecklist data-id="element-1612" data-mp="2mems1ypr3ppg" />
      </div>

      {API_BASE === null && <p className="mt-8 text-[12px] text-muted" data-id="element-1613" data-mp="28fn2mouez6s8">Bestellingen, afspraken en aantallen hierboven zijn voorbeelden. Zodra de backend draait, staan hier de echte.</p>}
    </div>;
}